import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useAuth } from '../stores/auth';
import { router } from './router';

export function App() {
  const bootstrap = useAuth((s) => s.bootstrap);
  const status = useAuth((s) => s.status);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (status === 'loading') {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-sm text-ink3">Loading…</div>
      </div>
    );
  }

  return <RouterProvider router={router} />;
}
